import React from 'react';

let timeout;
const milliSecSteps = 1;

function scroll(props) {
  const { from, to, duration, element, iterationCount = 1, callback } = props;

  if (iterationCount * milliSecSteps > duration || timeout === null) {
    callback();
    return;
  }
  const leftPosition =
    from + ((to - from) / duration) * milliSecSteps * iterationCount;
  setTimeout(function() {
    element.scroll({
      top: 0,
      left: leftPosition,
    });
    const isAnimationDone = to > from ? leftPosition > to : leftPosition < to;
    if (isAnimationDone) return;
    scroll({
      ...props,
      iterationCount: iterationCount + 1,
    });
  }, milliSecSteps);
}

const Carousel = props => {
  const {
    list,
    renderItem,
    animationDuration = 1000,
    interval = 5000,
    itemWidth,
  } = props;
  const [currentBanner, setCurrentBanner] = React.useState(1);
  const [isHovered, setIsHovered] = React.useState(false);
  const carouselRef = React.useRef();
  const isAnimating = React.useRef(false);
  const totalItemsCount = list?.length;

  const moveCarouselItem = (nextPosition = null) => {
    const newPosition =
      nextPosition !== null
        ? nextPosition
        : currentBanner === totalItemsCount
        ? 1
        : currentBanner + 1;

    const callback = () => {
      if (timeout !== null) {
        if (newPosition === 1)
          setTimeout(() => {
            if (carouselRef.current)
              carouselRef.current.scroll({
                top: 0,
                left: 0,
                behavior: 'auto',
              });
          }, 500);
        isAnimating.current = false;
        setCurrentBanner(newPosition);
      }
    };
    if (carouselRef.current) {
      isAnimating.current = true;
      const isAutoMode = nextPosition === null;
      scroll({
        element: carouselRef.current,
        from: itemWidth * (currentBanner - 1),
        to:
          newPosition === 1 && isAutoMode
            ? itemWidth * currentBanner
            : itemWidth * (newPosition - 1),
        duration: animationDuration,
        callback,
      });
    }
  };

  React.useEffect(() => {
    if (!isHovered && !isAnimating.current)
      timeout = setTimeout(() => {
        moveCarouselItem();
      }, interval);

    if (isHovered) {
      clearTimeout(timeout);
      timeout = undefined;
    }
  }, [currentBanner, isHovered]);

  React.useEffect(() => {
    return () => {
      clearTimeout(timeout);
      timeout = null;
    };
  }, []);

  return (
    <div className="carousel">
      <div className="carousel-item-wrapper" ref={carouselRef}>
        {list.concat(list[0]).map((item, index) => {
          return (
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            <div
              className="carousel-item"
              key={`carousel-item-${index}`}
              onMouseOver={() => setIsHovered(true)}
              onMouseOut={() => setIsHovered(false)}
            >
              {renderItem(item)}
            </div>
          );
        })}
      </div>
      <div className="pagination">
        {Array.from({ length: totalItemsCount }).map((item, index) => {
          return (
            <span
              onClick={() => {
                if (!isAnimating.current) {
                  clearTimeout(timeout);
                  timeout = undefined;
                  moveCarouselItem(index + 1);
                }
              }}
              className={`pagination-item${
                index + 1 === currentBanner ? ' active' : ''
              }`}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Carousel;
